export default (axios, alert) => ({
  get (perPage = 2) {
    return axios.get(`https://www.credimaxx.de/wp-json/wp/v2/posts?per_page=${perPage}`).then(({ data }) => data).catch(() => {
      alert('Fehler beim Laden der News', true)
    })
  }
})
